<template>
  <div
    style="position: fixed; left: 0; bottom: 0; z-index: 1000; width: 100%"
    class="fixed bottom-5 z-50 w-full flex items-center justify-center"
  >
    <div class="py-1 px-2 bg-black text-white text-sm shadow-lg">
      <slot />
    </div>
  </div>
</template>